import {Component, OnDestroy, OnInit} from '@angular/core';
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommandResponse} from '@shared/commands/command-base';
import {SmartGridService} from '@core/services/smart-grid.service';
import {AdminPanelConfig} from '@features/admin-panel/admin-panel.config';
import {MatDialog} from '@angular/material/dialog';
import {Store} from '@ngrx/store';
import {AdminPanelState} from '@features/admin-panel/store/reducers/admin-panel.reducer';
import {UpdateSolutionCommand} from '@features/admin-panel/commands/admin-panel.command';
import {UpdateSolutionAction} from '@features/admin-panel/store/actions/admin-panel.action';
import {UpdateSolutionComponent} from '@features/admin-panel/components/update-solution/update-solution.component';

@Component({
  standalone: false,
  selector: 'app-admin-panel-user-package-list',
  templateUrl: './admin-panel-user-package-list.component.html',
  styleUrls: ['./admin-panel-user-package-list.component.scss']
})
export class AdminPanelUserPackageListComponent implements OnInit, OnDestroy, IPlatformToolComponent {

  handler: IPlatformToolHandler;
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  selectedTab: TabModel;

  sourceType = 'Solution';

  constructor(
    private smartGridService: SmartGridService,
    private dialog: MatDialog,
    private store: Store<AdminPanelState>
  ) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  onLoad(): void {
    const userName = this.selectedTab?.tabData?.['UserName'];
    if (userName) {
      // `tabData.UserName` is the decoded username (literal `+`, `@`, …). The smart-grid config
      // interpolates `[USER_NAME]` into URL templates verbatim (`smart-grid.config.ts`
      // `getParameterizedString`), so a `+` would survive into the query string and be decoded as
      // a space by the backend. Encode here so that special characters (notably `+`) round-trip
      // correctly to the API. Mirrors `AdminPanelConfig.setSearchText`, which already encodes.
      AdminPanelConfig.setUserName(this.sourceType, encodeURIComponent(userName));
      this.smartGridService.initDataProvider(this.sourceType);
    }
  }

  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse): void {}
  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse): void {}
  onBeforeExecuteNextCommand(): boolean { return false; }
  onBeforeExecutePreviousCommand(): boolean { return false; }

  onValueChanged(event: any): void {
    if (event?.action?.id === 'Edit') {
      this.updateSolution(event.item);
    }
  }

  private updateSolution(item: any): void {
    const solution = {};
    for (const field in item.cells) {
      if (item.cells.hasOwnProperty(field)) {
        solution[field] = item.cells[field].displayText;
      }
    }
    const dialogRef = this.dialog.open(UpdateSolutionComponent, {
      width: '600px',
      disableClose: true,
      data: {solution}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result?.save) {
        const command = new UpdateSolutionCommand(result.solution);
        this.store.dispatch(new UpdateSolutionAction(command));
      }
    });
  }
}
